export var PaimonClusteringStrategy;
(function (PaimonClusteringStrategy) {
    PaimonClusteringStrategy["PAIMON_CLUSTERING_STRATEGY_ZORDER"] = "zorder";
    PaimonClusteringStrategy["PAIMON_CLUSTERING_STRATEGY_HILBERT"] = "hilbert";
    PaimonClusteringStrategy["PAIMON_CLUSTERING_STRATEGY_ORDER"] = "order";
})(PaimonClusteringStrategy || (PaimonClusteringStrategy = {}));
